import sortBy from 'lodash/sortBy';

const enums = {
  disputeMessageMessages: [
    {
      value: 'The trader never paid.',
    },
    {
      value: 'The trader is unable to verify they are in possession of the gift card. This is a trade requirement that is mentioned in the trade ad, trade requirements and first message sent to the trader.',
    },
    {
      value: 'This gift card does not have the appropriate funds for this trade to be paid.',
    },
    {
      value: 'The card number begins with 044. As mentioned in the ad and the trade instructions, we cannot accept cards that start with 044.',
    },
    {
      value: 'This card is merchandise/store credit. As mentioned in the ad and the trade instructions, we cannot accept merchandise/store credit.',
    },
    {
      value: 'This card was previously traded for.',
    },
    {
      value: 'We do not trade for this',
    },
  ],
  salesChannelTypes: [
    'G2A',
    'Self',
    'Raise.com',
    'Cardpool',
    'Gameflip',
    'Paxful',
  ],
  tradeStatus: [
    'Not funded',
    'Active funded',
    'Paid',
    'Cancelled system',
    'Cancelled buyer',
    'Cancelled seller',
    'Released',
    'Dispute open',
    'Dispute wins seller',
    'Dispute wins buyer',
  ],
  fileTypes: [
    {
      value: 'csv',
      label: 'CSV',
    },
    {
      value: 'image',
      label: 'Image',
    },
  ],
  accountStrategies: [
    {
      value: '',
      label: '',
    },
    {
      value: 'standard',
      label: 'standard',
    },
    {
      value: 'cc',
      label: 'cc (Legit Credit Card information',
    },
    {
      value: 'noProxy',
      label: 'noProxy (Not using the proxy browser)',
    },
    {
      value: '1gc ',
      label: '1gc (Redeeming max 1 GC per day + Gmail->Student->Gmail)',
    },
    {
      value: 'twitch',
      label: 'twitch (open prime through twitch)',
    },
    {
      value: 'purse',
      label: 'purse.io',
    },
  ],
  accountBuyStrategies: [
    {
      value: '',
      label: '',
    },
    {
      value: 'ship',
      label: 'ship (get item shipped to address)',
    },
    {
      value: 'digital',
      label: 'digital (get kindle book)',
    },
  ],
  salesChannelStatus: [
    {
      value: 'open',
      label: 'Open',
    },
    {
      value: 'shipped',
      label: 'Shipped',
      shippable: true,
    },
    {
      value: 'received',
      label: 'Received',
      shippable: true,
    },
    {
      value: 'exported',
      label: 'Exported & Sold',
    },
    {
      value: 'sold',
      label: 'Sold',
    },
    {
      value: 'fraud',
      label: 'Fraud',
    },
    {
      value: 'usingPurchase',
      label: 'Using for Purchase',
    },
    {
      value: 'usingCancel',
      label: 'Using to Cancel',
    },
  ],
  paymentStatus: [
    // these are also on serverside so make sure to update in both
    {
      value: 'received',
      label: 'Received',
      openTradeAvailable: true,
    },
    {
      value: 'verified',
      label: 'Verified',
      openTradeAvailable: true,
    },
    {
      value: 'verifiedAndCancelled',
      label: 'Verified & Cancelled',
    },
    {
      value: 'inChannel',
      label: 'In Channel',
    },
    {
      value: 'exported',
      label: 'Exported & Sold',
    },
    {
      value: 'sold',
      label: 'Sold',
    },
    {
      value: 'fraud',
      label: 'Fraud',
      openTradeAvailable: true,
    },
    {
      value: 'cancelled',
      label: 'Trade Cancelled',
    },
    {
      value: 'split',
      label: 'Split (Multiple trades)',
      openTradeAvailable: true,
    },
    {
      value: 'alreadyRedeemed',
      label: 'Already Redeemed',
      openTradeAvailable: true,
    },
    {
      value: 'receiptIssue',
      label: 'Receipt Issue',
      openTradeAvailable: true,
    },
    {
      value: 'usingPurchase',
      label: 'Using for Purchase',
    },
    {
      value: 'usingCancel',
      label: 'Using to Cancel',
    },
  ],
  tradeTypes: {
    walmart: 'Walmart Gift Card',
  },
  presetMessages: {
    global: [
      // 'Unfortunately, that is below the trade minimum set by paxful. Please reach out to their chat support and let them know that you\'d like the minimum trade value of .001btc to be lowered in light of the recent rise in btc. Thank you',
      // list of message that should always be available
      'I need the writing next to the card so I can verify you`re indeed in possession of the card you`re trying to trade. Thank you',
      // 'I need the writing next to the card. If you`re unable or unwilling, you`ll need to cancel the trade.',
      'I still need `Marxsmith trade ${tradeId}` written on a piece of paper next to the back of the card.',
      'Please cancel the trade',
    ],
    optional: {
      // optional message, needs a unique key to identify the message and the text of the message
      // 'iStillNeedTradeId': 'I still need `Marxsmith trade ${tradeId}` written on a piece of paper next to the card',
      'unverified': 'Hello! Please upload a photo of the card with the card number and pin exposed and "Marxsmith trade ${tradeId}" written on a piece of paper next to it. Then type in the card number and pin into the chat',
      'verified': 'Hello! Upload a photo of the back of the card with the card number and pin exposed. Then type in the card number and pin. Thank you',
      'checkCard': 'Please hold while I check if we accept that brand',
      'denied': 'Unfortunately, we do not accept that brand at this time. Thank you for reaching out. Have a good day.',
      'noCardNumberPinTypedIn': 'Please don\'t forget to type in the card number and pin. Thank you',
      'noCardNumberTypedIn': 'Please don\'t forget to type in the card number. Thank you',
      'noCardCodeTypedIn': 'Please don\'t forget to type in the card code. Thank you',

      'noCardInformation': 'Please don\'t forget to type in the card information. Thank you',
      'noCardCVV': 'Please don\'t forget to type in the card CVV (3 digits in the back of the card). Thank you',
      'noCardExpirationDate': 'Please don\'t forget to type in the card expiration date. Thank you',

      'amazonTypeCode': 'Hello, please type in the full Amazon card code starting with AQ , if there is more than one please write them separately.Thank you',
      'amazonRemovePackaging': 'Please make sure you take the card out of the packaging and expose the AQ code located in the back of the card',
      'amazonUploadCard': 'Please upload a photo of the card then type in the card code starting with AQ',
      'amazonUploadPhoto': 'Please upload a photo of the card then type in the card code starting with AQ. The only way the card is going to be redeemed and bitcoins released is if you type in the code. Dont forget to type the code. Thank you.',
      'uploadFullCard': 'Please upload the full card.',
      'uploadFullReceipt': 'Please upload the full receipt.',
      'activationReceipt': 'I need a photo of the activation receipt.',
      'receiptCash': 'I need a photo of the receipt that shows the payment method was cash.',
      'packagingPhoto': 'Please upload a photo of the packaging.',
      'uploadCorrupted': 'The photo you uploaded is corrupted and not visible. Please refresh your browser and try uploading the photo again',
      'fourCornersShowing': 'I need to see the full card to match the card to the receipt. In order to do so, I need the all 4 corners of the card showing so I can see both the card code and the serial number. Please upload a photo of the card with all 4 corners showing. Thank you',
    }
  },
  giftcards: [
    {
      // optionalMessages: ['unverified', 'verified', 'checkCard', 'denied', 'noCardNumberPinTypedIn', 'noCardCodeTypedIn'],
      value: 'OneVanilla VISA/MasterCard Gift Card',
      url: 'https://www.onevanilla.com',
      optionalMessages: ['noCardInformation', 'noCardCVV', 'noCardExpirationDate'],
      isBankCard: true,
      cantPurchase: true,
    },
    {
      // optionalMessages: ['unverified', 'verified', 'checkCard', 'denied', 'noCardNumberPinTypedIn', 'noCardCodeTypedIn'],
      value: 'Adidas Gift Card',
      url: 'https://wbiprod.storedvalue.com/WBI/lookupservlet?language=en',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Amazon Gift Card',
      url: 'https://www.amazon.com/redeem',
      keepUrl: 'https://www.amazon.ca/redeem',
      releaseModal: 'amazon',
      optionalMessages: [
        'amazonUploadCard',
        'amazonUploadPhoto',
        'noCardCodeTypedIn',
        'amazonTypeCode',
        'amazonRemovePackaging',
        'uploadFullCard',
        'uploadFullReceipt',
        'activationReceipt',
        'receiptCash',
        'packagingPhoto',
        'uploadCorrupted',
        'fourCornersShowing',
      ],
      sortPriority: 1,
      cantPurchase: true,
    },
    {
      value: 'AMC Theaters Gift Card',
      url: 'https://www.amctheatres.com/gift-cards/check-balance',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'ANY Gift Card Code',
      optionalMessages: ['unverified', 'verified', 'checkCard', 'denied', 'noCardNumberPinTypedIn'],
    },
    {
      value: 'Applesbee\'s Restaurant Gift Card',
      url: 'https://www.applebees.com/Check-Balance',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Babies R Us Gift Card',
      url: 'https://www.toysrus.com/toys/gifts/gift-cards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Bath and Body Works Gift Card',
      url: 'https://www.bathandbodyworks.com/giftcards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Bed Bath & Beyond Gift Card',
      url: 'https://www.bedbathandbeyond.com/store/account/check_balance.jsp',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Belk Gift Card',
      releaseModal: 'usingToCancel',
      url: 'https://www.belk.com/check-gift-card-balance/',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Best Buy Gift Card',
      releaseModal: 'usingToCancel',
      url: 'https://www-ssl.bestbuy.com/site/olspage.jsp?id=pcat17043&type=page&_DARGS=/site/en_US/global/fragments/olsglobalcheckbalancecenterwell.jsp',
      optionalMessages: ['noCardNumberPinTypedIn'],
      sortPriority: 1,
      cantPurchase: true,
    },
    {
      value: 'Cheesecake Factory Gift Card',
      url: 'https://thecheesecakefactory.cashstar.com/balance/',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Domino\'s Pizza Gift Card',
      url: 'https://dominosstore.wgiftcard.com/card/balance/checkPin/dominos/1',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'eBay Gift Card',
      url: 'https://giftcards.ebay.com/balance',
      optionalMessages: ['noCardNumberPinTypedIn'],
      sortPriority: 1,
    },
    {
      value: 'Fandango Gift Card',
      url: 'https://tickets.fandango.com/CheckBalance.aspx',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Foot Locker Gift Card',
      url: 'https://www.footlocker.com/catalog/gcbalanceform/?&cm=57831P',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Forever 21 Gift Card',
      releaseModal: 'usingToCancel',
      url: 'https://www.forever21.com/us/shop/Catalog/GiftCard',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'GameStop Gift Card',
      releaseModal: 'usingToCancel',
      url: 'https://www.gamestop.com/profiles/valuelookup.aspx',
      optionalMessages: ['noCardNumberPinTypedIn'],
      sortPriority: 1,
    },
    {
      value: 'Gamestop Gift Card',
      releaseModal: 'usingToCancel',
      url: 'https://www.gamestop.com/profiles/valuelookup.aspx',
      optionalMessages: ['noCardNumberPinTypedIn'],
      sortPriority: 1,
    },
    {
      value: 'Gift Cards',
      optionalMessages: ['unverified', 'verified', 'checkCard', 'denied', 'noCardNumberPinTypedIn'],
    },
    {
      value: 'gift cards of us based retailers',
      optionalMessages: ['unverified', 'verified', 'checkCard', 'denied', 'noCardNumberPinTypedIn'],
    },
    {
      value: 'Google Play Gift Card',
      url: 'https://play.google.com/store',
      optionalMessages: ['noCardCodeTypedIn'],
      sortPriority: 1,
    },
    {
      value: 'Home Depot Gift Card',
      hasHash: true,
      // url: 'https://secure2.homedepot.com/MCCCheckout/static/opc/giftcard.html#/giftcard',
      url: 'https://secure2.homedepot.com/mycheckout/giftcard#/giftcard',
      optionalMessages: ['noCardNumberPinTypedIn'],
      sortPriority: 1,
      cantPurchase: true,
    },
    {
      value: 'Jcpenny Gift Card',
      url: 'https://www.jcpenney.com/dotcom/jsp/giftcard/secure/giftCard.jsp',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'JCPenney Gift Card',
      url: 'https://www.jcpenney.com/dotcom/jsp/giftcard/secure/giftCard.jsp',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Lowe\'s Gift Card',
      url: 'https://www.lowes.com/cd_Check+Your+Gift+Card+Balance_1476134649292_',
      optionalMessages: ['noCardNumberPinTypedIn'],
      sortPriority: 1,
      cantPurchase: true,
    },
    {
      value: 'Macaroni Restaurant Gift Card',
      url: 'https://merchant.wgiftcard.com/rbc/brinker_resp',
      optionalMessages: ['noCardNumberTypedIn'],
    },
    {
      value: 'Macy\'s Gift Card',
      releaseModal: 'usingToCancel',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Nike Gift Card',
      url: 'https://store.nike.com/us/en_us/?l=shop%2Cgift_cards&balance=true',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Nordstrom Gift Card',
      url: 'https://secure.nordstrom.com/nordstrom-gift-cards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Office Depot Gift Card',
      releaseModal: 'usingToCancel',
      url: 'http://www.officedepot.com/customerservice/giftCardBalance.do',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Office Max Gift Card',
      releaseModal: 'usingToCancel',
      url: 'http://www.officedepot.com/customerservice/giftCardBalance.do',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Pizza Hut Gift Card',
      url: 'https://buypizzahutcards.com/Giftcard',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Playstation Network Gift Card',
      url: 'https://account.sonyentertainmentnetwork.com/login.action',
      optionalMessages: ['noCardCodeTypedIn'],
    },
    {
      value: 'Sears Gift Card',
      releaseModal: 'usingToCancel',
      url: 'http://www.sears.com/sears-gift-cards.html',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Sephora Gift Card',
      url: 'http://www.sephora.com/giftcards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Staples Gift Card',
      releaseModal: 'usingToCancel',
      url: 'https://wbiprod.storedvalue.com/WBI/lookupservlet?language=en&brand_id=staples',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Target Gift Card',
      releaseModal: 'usingToCancel',
      url: 'https://www.target.com/guest/gift-card-balance?lnk=checkyourbalanc&lnk=CheckyourTarget',
      optionalMessages: ['noCardNumberPinTypedIn'],
      sortPriority: 1,
      cantPurchase: true,
    },
    {
      value: 'Ulta Gift Card',
      url: 'https://www.ulta.com/ulta/guestservices/giftCards.jsp',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Victoria\'s Secret Gift Card',
      url: 'https://www.victoriassecret.com/victorias-secret-sport/gift-cards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Walmart Gift Card',
      releaseModal: 'usingToCancel',
      url: 'https://www.walmart.com/cservice/ProcessShoppingCard.do',
      optionalMessages: ['noCardNumberPinTypedIn'],
      sortPriority: 1,
      cantPurchase: true,
    },
    {
      value: 'Xbox Gift Card',
      url: 'https://redeem.microsoft.com/enter?ref=xboxcom&wa=wsignin1.0',
      optionalMessages: ['noCardCodeTypedIn'],
    },
    {
      value: 'Apple Gift Card',
      url: 'https://www.apple.com/shop/gift-cards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Apple Store Gift Card',
      url: 'https://www.apple.com/shop/gift-cards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Barnes &amp; Noble Gift Card',
      url: 'https://www.barnesandnoble.com/account/giftcard/checkbalance/',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Bass Pro Shop',
      url: 'http://www.basspro.com/shop/en/gift-cards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Burger King Gift Card',
      url: 'https://www.bk.com/crowncard',
      optionalMessages: ['noCardNumberTypedIn'],
    },
    {
      value: 'Chili\'s Restaurant Gift Card',
      url: 'https://chilisstore.wgiftcard.com/card/balance/check/chilis/1',
      optionalMessages: ['noCardNumberTypedIn'],
    },
    {
      value: 'Costco Cash Card',
      url: 'https://www.costco.com/costco-cash-card',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'CVS Gift Card',
      url: 'https://www.giftcardorder.net/cvs/mini.asp',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'CVS Pharmacy Gift Card',
      url: 'https://www.giftcardorder.net/cvs/mini.asp',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Dick Sporting Goods',
      url: 'https://m.dickssportinggoods.com/s/gift-cards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Dillards Gift Card',
      url: 'https://www.dillards.com/webapp/wcs/stores/servlet/GiftCardBalanceLookupView?storeId=301&langId=-1&catalogId=301',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Disney Gift Card',
      url: 'https://www.disneygiftcard.com/Manage',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Express Gift Card',
      url: 'https://www.express.com/browse/page.jsp?page=/browse/gadgets/gift-card-balance.jsp',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Finish Line',
      url: 'https://www.finishline.com/giftcards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Gap Gift Card',
      url: 'https://secure-oldnavy.gap.com/buy/checkout_giftCardBalance.do',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Banana Republic Gift Card',
      releaseModal: 'usingToCancel',
      url: 'https://secure-oldnavy.gap.com/buy/checkout_giftCardBalance.do',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'H&M Gift Card',
      url: 'https://www.hm.com/us/customer-service/giftcard-balance',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Kohls Gift Card',
      url: 'https://www.kohls.com/giftcard/gift_card_check_balance.jsp',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Lululemon',
      url: 'https://shop.lululemon.com/shop/luluGiftCards.jsp?mnid=ftr;en-US;gift-cards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'NEIMAN MARCUS GIFT CARD',
      url: 'https://www.neimanmarcus.com/assistance/assistance.jsp?view=gift_card',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Starbucks Card',
      url: 'https://www.starbucks.com/card',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'TJ Maxx Gift Card',
      url: 'https://tjmaxx.tjx.com/store/browse/giftCardBalance.jsp',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'Toys R Us',
      url: 'https://www.toysrus.com/toys/gifts/gift-cards',
      optionalMessages: ['noCardNumberPinTypedIn'],
    },
    {
      value: 'iTunes Gift Card',
      url: '',
      optionalMessages: [],
    },
  ],
  accounts: [
    {
      value: 'loan',
      label: 'Bank',
      currencies: ['USD','BTC','GFC'],
    },
    {
      value: 'bank1',
      label: 'Bank',
      currencies: ['USD'],
    },
    {
      value: 'coinbase',
      label: 'Coinbase',
      currencies: ['BTC', 'USD'],
    },
    {
      value: 'gdax',
      label: 'GDAX',
      currencies: ['BTC', 'USD'],
    },
    {
      value: 'paxful',
      label: 'Paxful',
      currencies: ['BTC', 'GFC'],
    },
    {
      value: 'purseio',
      label: 'Purse.io',
      currencies: ['BTC', 'GFC'],
    },
  ],
  paymentSortOptions: [
    {
      value: 'remainingValue',
      label: 'Remaining Value',
    },
    {
      value: '_id',
      label: 'Date',
    },
  ],
  disputeReasons: [
    //
    {
      value: 'buyer_unresponsive_vendor',
      label: 'Buyer unresponsive vendor',
    },
    {
      value: 'buyer_payment_issue',
      label: 'Buyer Payment Issue',
    },
    {
      value: 'buyer_other',
      label: 'Buyer Other',
    },
    {
      value: 'vendor_coinlocker',
      label: 'Vendor Coinlocker',
    },
    {
      value: 'vendor_payment_issue',
      label: 'Vendor Payment Issue',
    },
    {
      value: 'vendor_other',
      label: 'Vendor Other',
    },
  ],
  currencies: [
    {
      value: 'USD',
      label: 'USD',
    },
    {
      value: 'CAD',
      label: 'CAD',
    },
    {
      value: 'GBP',
      label: 'GBP',
    },
    {
      value: 'AUS',
      label: 'AUS',
    },
  ],
  orderStatus: [
    {
      value: 'orderPlaced',
      label: 'orderPlaced',
    },
    {
      value: 'cancelled',
      label: 'cancelled',
    },
    {
      value: 'outForDelivery',
      label: 'outForDelivery',
    },
    {
      value: 'delivered',
      label: 'delivered',
    },
  ]
};

enums.giftcards = sortBy(enums.giftcards, card=> card.value.toLowerCase());

enums.giftcardLinks = {};

enums.giftcards.forEach(giftcard=>{
  enums.giftcardLinks[giftcard.value] = giftcard;
});

enums.giftcardsMap = enums.giftcardLinks;

enums.salesChannelStatusMap = {};
enums.salesChannelStatus.forEach(channel => {
  enums.salesChannelStatusMap[channel.value] = channel;
});

enums.paymentStatusMap = {};
enums.paymentStatus.forEach(channel => {
  enums.paymentStatusMap[channel.value] = channel;
});

enums.accountByValue = {};
enums.accounts.forEach(account=> enums.accountByValue[account.value] = account);

module.exports = enums;



// WEBPACK FOOTER //
// ./src/app/constants/enums.js